import React from "react";
import "./PlaceOrder.css";
const PlaceOrder = () => {
  return <div>hi</div>;
};

export default PlaceOrder;
